const getParamNameRegex = /\/:(\w*)\/?/g;

export const formatHref = (
  path: string,
  options: Record<string, string | undefined>
) =>
  path.replace(getParamNameRegex, (_match, optionName) => {
    if (options[optionName]) {
      return `/${options[optionName]}/`;
    }

    // else strip off the param
    return "/";
  });
